import { FONT_BASE } from '../../constants/AppFonts';

export class HudPlayerCoins extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);
    const panel = scene.add.image(0, 0, 'graphics', 'coin_display');
    scene.game.player.on('UPDATED', this.handlePlayerUpdated, this);
    this._label = scene.add
      .text(panel.width * 0.5 - 20, 0, scene.game.player.coins || 0, {
        align: 'right',
        color: '#FFFFFF',
        fontFamily: FONT_BASE.REGULAR,
        fontSize: 28,
      })
      .setOrigin(1, 0.5);
    this.add([panel, this._label]);
  }

  handlePlayerUpdated(player) {
    this._label.text = player.coins;
  }

  get displayWidth() {
    return 200;
  }

  get displayHeight() {
    return 60;
  }

  destroy() {
    this.scene.game.player.off('UPDATED', this.handlePlayerUpdated, this);
    super.destroy();
  }
}
